import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { PengDiseaseScreen } from './pengDiseaseScreen';
import { ArcContainer } from '../../../shared/components/arcContainer';
import { Box, Modal } from '@mui/material';
import { TextWithInfoIcon } from '../../../shared/components/textWithInfoIcon';
import InfoIcon from '../../../assets/icons/infoIcon.svg';
import ChronicDiseaseIcon from '../../../assets/icons/chronicDisease.svg';
import pengGuidePDF from '../../../assets/pdf/PENG_Guide.pdf';
import { NavigationButtons } from '../../../shared/components/navigationButtons';
import { MixedModal } from '../../../shared/components/modal/MixedModal';
import { BoxStyled } from '../../patientInformation/style';
import { useAppSelector } from '../../../store/hooks';
import { metaDataSelector } from '../../../store/globalSelectors';
import { AddOnInfoModal } from '../../../shared/components/modal/addOnInfoModal';
export const Peng2018 = () => {
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const { estimatingRequirements } = useAppSelector(metaDataSelector);
  const { peng2018 } = estimatingRequirements;
  const { disease } = peng2018;

  const openPDF = () => {
    window.open(pengGuidePDF, '_blank');
  };

  const handleCloseModal = () => {
    openInfoModal && setOpenInfoModal(false);
  };

  return (
    <>
      <BoxStyled>
        {/* Top Bar (title + info icon) */}
        <TextWithInfoIcon
          title={'Peng 2018'}
          icon={InfoIcon}
          fontSize={'1.625rem'}
          lineHeight={'1.375rem'}
          variant={'h1'}
          handleIconClick={() => setOpenInfoModal(true)}
          testId="PengInfoPopup"
        />

        <ArcContainer icon={ChronicDiseaseIcon}>
          <Routes>
            <Route
              index
              element={
                <PengDiseaseScreen
                  handleIconClick={openPDF}
                  testId="PengDiseasePopup"
                />
              }
            />
          </Routes>
        </ArcContainer>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, mt: 2 }}>
          <NavigationButtons
            nextRoute={'/peng2018/pal'}
            nextDisabled={Object.keys(disease).length === 0}
          />
        </Box>
      </BoxStyled>
      <Modal
        open={openInfoModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <AddOnInfoModal
          heading1={`REE`}
          description1={` = Resting Energy Expenditure`}
          title={`Reference:`}
          content={`Todorovic VE. Mafrici B. A Pocket Guide to Clinical Nutrition 2018. 5th edition.`}
          onClose={handleCloseModal}
        />
      </Modal>
    </>
  );
};
